import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const WhitelistSegmentRBAC = {
  pageID: '86514b8a2859ab762fe6149f9bce0b63',
  elementID: {
    View: '0631fc8410e5d7b36aaadc3c9df2c514',
    Create: 'f5a4725ee172247b0b0d63f3d0003c73',
    Edit: '0632379ca9e5d7b36aaadc3cb6325eaf',
    Delete: '159a6ef72572247b0b0d6baaf0ed834a',
  },
} as const

export const useRBACWhitelistSegmentPage = createUseRBAC(WhitelistSegmentRBAC.elementID)

export type UseRBACWhitelistSegmentPageType = ReturnType<typeof useRBACWhitelistSegmentPage>
